// extracted by mini-css-extract-plugin
export default {"siteHeader":"Header_siteHeader__9ND60","headerNavbar":"Header_headerNavbar__fO+Gt","navbarBrand":"Header_navbarBrand__dkO0R","navbarBrandLogo":"Header_navbarBrandLogo__3owVL"};